import {Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {devolverDiaSem} from '../models/semana.model';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';

import * as lodash from 'lodash';
import {SemanaServices} from '../services/semana.services';
import {OPCCAT, OPCLOC, OPCNEG} from '../../variables';
import {EmpleadoModel} from '../../CoreModule/models/empleado.model';
import {EmpleadoServices} from '../../CoreModule/services/empleado.services';
import * as moment from 'moment';

export class HorarioComponent {

}

@Component({
  selector: 'input-horario',
  templateUrl: '../templates/horarios/input.horario.template.html'
})
export class InputHorarioComponent implements OnInit {

  public horaInicio: any;
  public horaCierre: any;
  @Input()
  public dia: any;

  @Input()
  public indexSem: any;
  @Input()
  public diaSem: any;

  ngOnInit() {
    if (this.diaSem) {
      // esta opcion va a estar deprecada
      // let hDia = moment(this.diaSem.hi, 'HH:mm');
      // let hCie = moment(this.diaSem.hc, 'HH:mm');

      let hDia = moment(this.diaSem.horaInicio, 'HH:mm');
      let hCie = moment(this.diaSem.horaCierre, 'HH:mm');

      if (hDia.isValid())
        this.diaSem.hi = hDia.format('HH:mm');
      else
        this.diaSem.hi = '';

      if (hCie.isValid())
        this.diaSem.hc = hCie.format('HH:mm');
      else
        this.diaSem.hc = '';

      this.diaSem.nombre = devolverDiaSem(this.indexSem);
      this.diaSem.dia = this.indexSem;
    }

    //
    // this.horaInicio = this.dia.horaInicio;
    // this.horaCierre = this.dia.horaCierre;


  }

  // devolverDia(dia:any){
  //   switch (dia) {
  //     case 0: return "Domingo";
  //     case 1: return "Lunes";
  //     case 2: return "Martes";
  //     case 3: return "Miercoles";
  //     case 4: return "Jueves";
  //     case 5: return "Viernes";
  //     case 6: return "Sabado";
  //   }
  // }
}

@Component({
  selector: 'asig-horario',
  templateUrl: '../templates/horarios/asignacion.horarios.template.html'
})
export class AsignHorarioComponent {

  anoSelect: number;
  semSelect: any;
  opcSem: any[] = [];
  cantDias: any[] = [];
  mismoHorario: boolean = false;

  filtroAsign: number = 1;
  todasTiendas: TiendaEntity[] = [];
  tiendaSelect: TiendaEntity;
  configTiendas: any = {'placeholder': 'Seleccione una tienda', 'sourceField': ['payload', 'label']};
  opcTiendas: any[] = [];

  @ViewChildren(InputHorarioComponent)
  queryHorarios: QueryList<InputHorarioComponent>;

  opcNegocio: string[] = OPCNEG;
  opcLocacion: string[] = OPCLOC;
  opcCategoria: string[] = OPCCAT;

  filtroLoc: string = '';
  filtroCat: string = '';
  filtroNeg: string = '';

  tiendasFilt: TiendaEntity[] = [];

  tiendasQuitar: any[] = [];


  constructor(private ts: TiendaServices, private ss: SemanaServices) {
    for (let i = 0; i < 7; i++) {
      this.cantDias.push({
        dia: i,
        nombre: devolverDiaSem(i),
        horaInicio: '',
        horaCierre: ''
      });
    }

    for (let j = 1; j < 53; j++) {
      this.opcSem.push(j);
    }

    this.ts.getAllTiendas().subscribe(d => {
      this.todasTiendas = d.data.tiendas;
      for (let t of d.data.tiendas) {
        this.opcTiendas.push({
          id: t.id,
          payload: {label: t.nombre}
        });
      }
    });

  }

  selectTienda(tienda: any) {
    console.log(tienda);
    this.tiendaSelect = this.todasTiendas.find(t => t.id = tienda.id);
    console.log(this.tiendaSelect);
  }

  cambiarMismoHorario() {

    if (this.mismoHorario) {
      let lunes = this.queryHorarios.find(item => item.dia.dia == 0);

      if (lunes != undefined) {
        if (lunes.dia.horaInicio != '') {
          this.queryHorarios.map((item) => {

            if (item.dia.dia != 5 && item.dia.dia != 6) {
              item.dia.horaInicio = lunes.dia.horaInicio;
              item.dia.horaCierre = lunes.dia.horaCierre;
            }
          });
        }
      }
    }
  }

  filtrarTiendas() {
    this.tiendasFilt = lodash.clone(this.todasTiendas);

    console.log(`${this.filtroLoc} ${this.filtroCat} ${this.filtroNeg}`);

    if (this.filtroNeg != '')
      this.tiendasFilt = this.tiendasFilt.filter(t => t.negocio == this.filtroNeg);

    if (this.filtroCat != '')
      this.tiendasFilt = this.tiendasFilt.filter(t => t.categoria == this.filtroCat);

    if (this.filtroLoc != '')
      this.tiendasFilt = this.tiendasFilt.filter(t => t.locacion == this.filtroLoc);

    console.log(this.tiendasFilt);
  }


  quitarTienda() {
    console.log(this.tiendasQuitar);
    this.tiendasFilt = this.tiendasFilt.filter(t => {

      let found = this.tiendasQuitar.find(q => q == t.id);

      if (found)
        return false;
      else
        return true;
    });

    console.log(this.tiendasFilt);
    this.tiendasQuitar = [];
  }

  guardarHorarios() {
    // console.log(this.cantDias);
    // console.log(this.anoSelect);
    // console.log(this.semSelect);
    // console.log(this.tiendaSelect);
    // console.log(this.tiendasFilt);

    let fecha = `${this.anoSelect}-${this.semSelect}`;
    let tiendasAsignar: string[] = [];

    if (this.filtroAsign == 1) {
      tiendasAsignar.push(this.tiendaSelect.idDB);
    } else {
      for (let t of this.tiendasFilt) {
        tiendasAsignar.push(t.idDB);
      }
    }

    this.ss.guardarHorarios(fecha, tiendasAsignar, this.cantDias).subscribe(d => {
      console.log(d);
      console.log(d.data.crearHorarios);
      alert(d.data.crearHorarios);
    });
  }

}


@Component({
  selector: 'hor-emple',
  templateUrl: '../templates/horarios/asignacion.horemple.template.html',
  styleUrls: ['../styles/accordion.styles.scss']
})
export class AsignacionHorEmpleComponent implements OnInit {


  @Input()
  tienda: TiendaEntity;
  @Input()
  empleados: EmpleadoModel[] = [];

  @Input()
  editarHorario: boolean = false;

  @Input()
  editarHorarioSuper: boolean = false;

  cantHoras: number[] = [];

  horaMin: number = Number.MAX_VALUE;
  horaMax: number = Number.MIN_VALUE;

  horasActivas: any[] = [];

  @Input()
  fechaActual: any;

  fechaSemana: any;


  constructor() {
    for (let i = 0; i < 24; i++)
      this.cantHoras.push(i);

    for (let d = 0; d < 7; d++) {

      let actH: any[] = [];
      for (let i = 0; i < 24; i++) {
        actH.push(false);
        actH.push(false);
      }

      this.horasActivas.push(actH);
    }


  }

  getMetaHora(dia: any, hora: any, e: EmpleadoModel) {
    if (e.mallaEmple) {
      if (e.mallaEmple.meta[dia].metaHora[hora])
        return e.mallaEmple.meta[dia].metaHora[hora];
      else
        return 0;
    } else
      return 0;
  }

  // comprobarHoraHabilitada(dia:any, hora:any, compensado){
  //   return (!this.horasActivas[dia][hora] || compensado);
  // }

  compensandoDia(event: any, empleado: EmpleadoModel, dia: any) {

    if (event) {
      empleado.horario[dia].horasAct.map((h: any) => {
        h.estado = false;
      });
    }

  }


  ngOnInit() {

    if (this.empleados.length > 0)
      this.fechaSemana = moment(this.empleados[0].sem.fecha);



    this.tienda.horario.map((ht, index) => {
      let hi = moment(ht.hi, 'hh:mm').hour();
      let hc = moment(ht.hc, 'hh:mm').hour();
      let mi = moment(ht.hi, 'hh:mm').minutes();
      let mc = moment(ht.hc, 'hh:mm').minutes();

      if (this.editarHorario || this.editarHorarioSuper) {

        let start = hi * 2;


        if (mi == 30)
          start += 1;

        let end = hc * 2;
        if (mc == 30)
          end += 1;

        // habilitar semana final abril 2022
        // if (this.editarHorarioSuper) {
          for (let h = start; h < end; h++) {
            this.horasActivas[index][h] = true;
          }
        // } else {

          // habilitar semana final abril 2022
          // if (this.fechaActual) {
          //   // this.fechaActual
          //   let fechaFin = moment(this.fechaSemana).add(6, 'd');
          //
          //   // comprobacion si el dia este entre el dia lunes - domingo de la semana
          //   if (this.fechaActual.isBetween(this.fechaSemana, fechaFin, undefined, '[]')) {
          //     let diaSem = this.fechaActual.day();
          //
          //     if (diaSem == 0)
          //       diaSem = 6;
          //     else
          //       diaSem--;
          //     console.log("editando3");
          //
          //     // comprobacion si se puede editar el dia dependiendo de la fecha actual
          //     if (index >= diaSem) {
          //       for (let h = start; h < end; h++) {
          //         this.horasActivas[index][h] = true;
          //       }
          //     }
          //   }
          // }
          // else{
          //   for (let h = start; h < end; h++) {
          //     this.horasActivas[index][h] = true;
          //   }
          // }

        // }


      }


      if (hi < this.horaMin) {
        this.horaMin = hi;

      }

      if (hc > this.horaMax) {
        this.horaMax = hc;

      }


    });

    // console.log(this.horasActivas);

  }

  habilitarCompensado(index: any) {

    // habilitar semana final abril 2022
    // if (this.editarHorarioSuper)
      return true;

    if (this.fechaActual) {

      let fechaFin = moment(this.fechaSemana).add(6, 'd');

      // comprobacion si el dia este entre el dia lunes - domingo de la semana
      if (this.fechaActual.isBetween(this.fechaSemana, fechaFin, undefined, '[]')) {
        let diaSem = this.fechaActual.day();

        if (diaSem == 0)
          diaSem = 6;
        else
          diaSem--;

        // comprobacion si se puede editar el dia dependiendo de la fecha actual
        if (index >= diaSem) {
         return true;
        }
      }
    }
    else{
      return true;
    }
    return false;
  }
}





